import { Tabs } from "flowbite-react";
import { LeadInfo } from "../forms/LeadInfo";
import { FaCircleUser } from "react-icons/fa6";
import { leadsTheme } from "./LeadsStyle";
import LeadAddress from "../forms/LeadAddress";
import LeadDocuments from "../forms/LeadDocuments";
import { FaHome } from "react-icons/fa";
import { IoDocumentAttach } from "react-icons/io5";

export function LeadDashboard() {


  return (
    <div className="relative flex justify-center w-full h-full overflow-y-auto bg-white dark:bg-white dark:text-black">
      <section className="max-w-7xl w-full p-2">
        <Tabs
          className="tabs-style"
          theme={leadsTheme}
          aria-label="Default tabs"
        >
          <Tabs.Item
            icon={FaCircleUser}
            title={
              <div className="tabs-name-style">
                Informações
              </div>
            }
          >
            <LeadInfo />
          </Tabs.Item>

          <Tabs.Item
            icon={FaHome}
            title={
              <div className="tabs-name-style">
                Endereço
              </div>
            }
          >
            <LeadAddress />
          </Tabs.Item>

          <Tabs.Item
            icon={IoDocumentAttach}
            title={
              <div className="tabs-name-style">
                Documentos
              </div>
            }
          >
            <LeadDocuments />
          </Tabs.Item>

        </Tabs>
      </section>
    </div>
  )
}